export default  () => {
    return (
        <div className="container p-5">
            Laporan Menu
        </div>
    )
}